import React from 'react';
import PropTypes from 'prop-types';
import { Line, FeatureFlagName, Checkbox } from '../styles';
import { camelCaseToTitleCase } from '../helper';
import { InlineErrorMessage } from './styles';

const FeatureFlagLine = ({
  featureFlagName,
  featureFlagError,
  onToggleFeatureFlag,
  enabled,
}) => (
  <Line style={{ display: 'flex', alignItems: 'center' }}>
    <FeatureFlagName>
      {camelCaseToTitleCase(featureFlagName)}
    </FeatureFlagName>
    <Checkbox onChange={() => onToggleFeatureFlag(!enabled)} checked={enabled} />
    {featureFlagError && <InlineErrorMessage>{featureFlagError}</InlineErrorMessage>}
  </Line>
);

FeatureFlagLine.defaultProps = {
  featureFlagError: '',
};

FeatureFlagLine.propTypes = {
  featureFlagName: PropTypes.string.isRequired,
  onToggleFeatureFlag: PropTypes.func.isRequired,
  featureFlagError: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
};

export default FeatureFlagLine;
